import axiosPost from "./axiosPost";

export const SFHotelUpd = async (credentials, params = {}) => {
    const body = {
        service: "SFHotelUpd",
        params: {
            SFHotelId: params?.SFHotelId,
            SFHotelNombre: params?.SFHotelNombre,
            SFHotelDomicilioCalle: params?.SFHotelDomicilioCalle,
            SFHotelDomicilioCasa: params?.SFHotelDomicilioCasa,
            SFHotelDomicilioCPA: params?.SFHotelDomicilioCPA,
            localidadId: params?.localidadId,
            SFHotelLatitud: params?.SFHotelLatitud,
            SFHotelLongitud: params?.SFHotelLongitud,
            SFHotelCUIT: params?.SFHotelCUIT,
            SFHotelCheckin: params?.SFHotelCheckin,
            SFHotelCheckout: params?.SFHotelCheckout,
            SFHotelEmail: params?.SFHotelEmail,
            SFHotelTelefono: params?.SFHotelTelefono,
            SFHotelVersion: params?.SFHotelVersion,
            SFHotelStatus: params?.SFHotelStatus,
        },
    };

    return await axiosPost(body, credentials);
};
